/* eslint-disable no-unused-expressions */
/*global google*/

import React, { Component } from 'react';
import {
	withGoogleMap,
	GoogleMap,
	DirectionsRenderer,
} from 'react-google-maps';

import Store from '../../utils/Store';

class Map extends Component {
	static contextType = Store;
	state = {
		directions: null,
		currentLocation: { lat: 0, lng: 0 },
		origin: { lat: 23.810331, lng: 90.412521 },
		destination: { lat: 25.04561, lng: 91.387138 },
		distance: '',

		// origin: 'ChIJgWsCh7C4VTcRwgRZ3btjpY8',
		// destination: 'ChIJm9OEM7YpUTcRsBjBs9ywnkU',
	};
	// originLatLng={originLatLng} distLatLng={distLatLng}

	async UNSAFE_componentWillMount() {
		const directionsService = await new google.maps.DirectionsService();

		// 	// const { originLatLng, distLatLng } = this.props;

		// 	// console.log('this originLatLng = ', originLatLng);
		// 	// console.log('this distLatLng = ', distLatLng);

		// 	// let origin = { lat: 23.810331, lng: 90.412521 };
		// 	// let destination = { lat: 25.04561, lng: 91.387138 };

		// 	// const origin = { lat: 40.756795, lng: -73.954298 };
		// 	// const destination = { lat: 41.756795, lng: -78.954298 };

		directionsService.route(
			{
				origin: this.state.origin,
				destination: this.state.destination,
				travelMode: google.maps.TravelMode['DRIVING'],
			},
			(result, status) => {
				if (status === google.maps.DirectionsStatus.OK) {
					this.setState({
						directions: result,
					});
					console.log('distance =', result.routes[0].legs[0].distance.text);
					console.log('distance =', result.routes[0].legs[0].duration.text);
				} else {
					console.error(`error fetching directions ${result}`);
				}
			}
		);
	}

	//current location

	//UNSAFE_componentWillReceiveProp

	async UNSAFE_componentWillReceiveProps(nextProps) {
		const { originLatLng, distLatLng } = await nextProps;
		if (originLatLng && distLatLng) {
			// console.log('this originLatLng = ', originLatLng);
			// console.log('this distLatLng = ', distLatLng);

			this.setState({
				origin: {
					lat: originLatLng.lat ? originLatLng.lat : 23.810331,
					lng: originLatLng.lng ? originLatLng.lng : 90.412521,
				},

				destination: {
					lat: distLatLng.lat ? distLatLng.lat : 25.04561,
					lng: distLatLng.lng ? distLatLng.lng : 91.387138,
				},
			});

			const directionsService = await new google.maps.DirectionsService();

			directionsService.route(
				{
					origin: this.state.origin,
					destination: this.state.destination,
					travelMode: google.maps.TravelMode['DRIVING'],
				},
				(result, status) => {
					if (status === google.maps.DirectionsStatus.OK) {
						// console.log('distance =', result.routes[0].legs[0].distance.value);
						// let distanceValue = result.routes[0].legs[0].distance.value / 1000;
						// let distance = Math.floor(distanceValue);
						// getDistance(distance);
						this.setState({
							directions: result,
							// distance: distance,
						});
					} else {
						console.error(`error fetching directions ${result}`);
					}
				}
			);
		}
		// console.log('this state Origin = ', this.state.origin);
		// console.log('this state dis = ', this.state.destination);
	}

	render() {
		const GoogleMapExample = withGoogleMap((props) => (
			<GoogleMap
				defaultCenter={{ lat: 23.810331, lng: 90.412521 }}
				defaultZoom={13}
			>
				<DirectionsRenderer directions={this.state.directions} />
			</GoogleMap>
		));

		return (
			<div>
				<GoogleMapExample
					containerElement={<div style={{ height: `85vh`, width: '90%' }} />}
					mapElement={<div style={{ height: `100%` }} />}
				/>
			</div>
		);
	}
}

export default React.memo(Map);
